import {update} from "lodash-es";
import {addListener} from "process";

const productOptionsCl = {
  popup: "product-popup-js",
  popupOverlay: "product-popup-overlay-js",
  popupCloseBtn: "product-popup-close-js",
  popupConfirmBtn: "product-popup-confirm-button-js",
  popupOpenEl: "product-popup-open-js",
  colorRadio: "product-popup-radio-js",

  quantityWrapper: "product-quantity-wrapper-js",
  quantityInput: "product-options-quantity-input-js",
  quantityPlusBtn: "product-quantity-plus-js",
  quantityMinusBtn: "product-quantity-minus-js",

  strengthWrapper: "product-strength-wrapper-js",
  strengthRadio: "product-strength-radio-js",

  priceTag: "product-options-price-js",
  basketBtn: "product-options-basket-btn-js",
};

/* GENERAL FUNCTIONS - START */

const resetProductQuantity = function (quantityInput) {
  quantityInput.value = 1;
  quantityInput.setAttribute("value", 1);
};

const switchPriceTag = function (chosenVariant) {

  // console.log(chosenVariant);

  const priceTags = document.querySelectorAll("." + productOptionsCl.priceTag);
  const beforeSalePrice = chosenVariant.getAttribute('data-variant-original-price-currency');
  const activePrice = chosenVariant.getAttribute('data-variant-price-currency');

  let isOnSale = false;

  if(chosenVariant.getAttribute('data-variant-original-price') == "" || chosenVariant.getAttribute('data-variant-original-price') == null) {
    isOnSale = false;
  } else {
    isOnSale = true;
  }

  // show the sale price [now / was] 
  if(isOnSale) {
    document.querySelector(`[sale-was-ref]`).innerHTML = `Was ${beforeSalePrice}`;
    document.querySelector(`[active-price-ref]`).classList.add(`product-main__top-details-price--sale`);
    document.querySelector(`[active-price-ref]`).innerHTML = `Now ${activePrice}`;
    document.querySelector(`[sale-was-ref]`).classList.remove('visually-hidden');
  } else {
    document.querySelector(`[sale-was-ref]`).classList.add('visually-hidden');
    document.querySelector(`[active-price-ref]`).classList.remove(`product-main__top-details-price--sale`);
    document.querySelector(`[active-price-ref]`).innerHTML = `<span>${activePrice}</span>`;
  }

  priceTags.forEach((tag) => {

    const tagMoneyEl = tag.querySelector(".money") || tag;
    const previousPrice = tag.getAttribute("data-total-price");

    if (tag.hasAttribute("original-price")) {
      tag.setAttribute(
        "data-total-price",
        chosenVariant.getAttribute("data-variant-original-price"),
      );
      tag.setAttribute(
        "data-product-price",
        chosenVariant.getAttribute("data-variant-original-price"),
      );
      tag.setAttribute(
        "data-product-price-currency",
        chosenVariant.getAttribute("data-variant-original-price-currency"),
      );
      tagMoneyEl.textContent = tagMoneyEl.textContent.replace(
        previousPrice,
        tag.getAttribute("data-product-price"),
      );
      return;
    }

    tag.setAttribute(
      "data-total-price",
      chosenVariant.getAttribute("data-variant-price"),
    );
    tag.setAttribute(
      "data-product-price",
      chosenVariant.getAttribute("data-variant-price"),
    );
    tag.setAttribute(
      "data-product-price-currency",
      chosenVariant.getAttribute("data-variant-price-currency"),
    );
    tagMoneyEl.textContent = tagMoneyEl.textContent.replace(
      previousPrice,
      tag.getAttribute("data-product-price"),
    );
  });
};

const calculatePriceTag = function (action = "plus", quantity = 1) {
  const priceTags = document.querySelectorAll("." + productOptionsCl.priceTag);

  const renderNewPrice = function (priceTag, previousTotalStr, newTotal) {
    const tagMoneyEl = priceTag.querySelector(".money") || priceTag;
    priceTag.setAttribute("data-total-price", newTotal.toFixed(2));
    tagMoneyEl.textContent = tagMoneyEl.textContent.replace(
      previousTotalStr,
      newTotal.toFixed(2),
    );
  };

  priceTags.forEach((tag) => {
    if(tag.getAttribute('data-ignore-price') == "true") {
      return;
    } else {
      const previousTotalStr = tag.getAttribute("data-total-price");
      const previousTotal = +tag.getAttribute("data-total-price");
      const productPrice = +tag.getAttribute("data-product-price");
      let newTotal;
      if (action === "plus") {
        newTotal = previousTotal + productPrice * quantity;
        renderNewPrice(tag, previousTotalStr, newTotal);
      } else if (action === "minus") {
        newTotal = previousTotal - productPrice * quantity;
        renderNewPrice(tag, previousTotalStr, newTotal);
      } else if (action === "manual") {
        newTotal = productPrice * quantity;
        renderNewPrice(tag, previousTotalStr, newTotal);
      }
    }
  });
};

/* GENERAL FUNCTIONS - END */

/* PRODUCT QUANTITY - START */

const updateProductQuantity = function (quantityInput, action = "plus") {
  const currentQuantity = +quantityInput.value;
  let newQuantity;

  if (action === "plus") {
    newQuantity = currentQuantity + 1;
    quantityInput.value = newQuantity;
    quantityInput.setAttribute("value", newQuantity);

    calculatePriceTag();
  } else if (action === "minus" && currentQuantity > 1) {
    newQuantity = currentQuantity - 1;
    quantityInput.value = newQuantity;
    quantityInput.setAttribute("value", newQuantity);

    calculatePriceTag("minus");
  } else if (action === "manual") {
    newQuantity = currentQuantity;
    quantityInput.value = newQuantity;
    quantityInput.setAttribute("value", newQuantity);
    calculatePriceTag("manual", newQuantity);
  }
};

const addQuantityEvents = function (quantityWrapper) {
  const quantityInput = quantityWrapper.querySelector(
    "." + productOptionsCl.quantityInput,
  );

  const basketBtn = document.querySelector("." + productOptionsCl.basketBtn);

  quantityWrapper.addEventListener("click", (e) => {
    if (e.target.closest("." + productOptionsCl.quantityPlusBtn)) {
      updateProductQuantity(quantityInput);
    }
    if (e.target.closest("." + productOptionsCl.quantityMinusBtn)) {
      updateProductQuantity(quantityInput, "minus");
    }
  });

  quantityInput.addEventListener("keyup", (e) => {
    if (e.target.value < 1) {
      e.target.value = 1;
    }
    updateProductQuantity(quantityInput, "manual");
  });
};

const initProductQuantity = function () {
  const quantityWrapper = document.querySelector(
    "." + productOptionsCl.quantityWrapper,
  );
  if (!quantityWrapper) return;

  addQuantityEvents(quantityWrapper);
};

/* PRODUCT QUANTITY - END */

/* PRODUCT POPUP - START */

const hideProductPopup = function (currentPopup) {
  currentPopup.removeAttribute("active");
};

const showProductPopup = function (popup) {
  popup.setAttribute("active", "");
};

const updateDropdown = function (dropdownInput, clickedRadio, quantityInput) {
  dropdownInput.value = `${clickedRadio.getAttribute("data-colour-option")}`;
  dropdownInput.setAttribute("filled", "");
  resetProductQuantity(quantityInput);
  switchPriceTag(clickedRadio);
};

const addPopupEvents = function (openEl, quantityInput) {
  const popup = openEl.closest(
    "." + productOptionsCl.popupOpenEl,
  ).nextElementSibling;
  const dropdownInput = openEl.querySelector("input");

  const checkedRadio = popup.querySelector("input[checked]");
  if (checkedRadio) dropdownInput.value = checkedRadio.value;
  dropdownInput.setAttribute("filled", "");

  openEl.addEventListener("click", (e) => {
    showProductPopup(popup);
  });

  popup.addEventListener("click", (e) => {
    if (
      e.target.closest("button." + productOptionsCl.popupCloseBtn) ||
      e.target.closest("button." + productOptionsCl.popupConfirmBtn) ||
      e.target.classList.contains(productOptionsCl.popupOverlay)
    ) {
      hideProductPopup(popup);
    }
    if (e.target.closest("." + productOptionsCl.colorRadio)) {
      const radio = e.target
        .closest("." + productOptionsCl.colorRadio)
        .querySelector("input");
      hideProductPopup(popup);
      if (radio.hasAttribute("out-of-stock")) return;
      document.querySelector("." + productOptionsCl.basketBtn).disabled = false;
      updateDropdown(dropdownInput, radio, quantityInput);
    }
  });
};

const initProductPopup = function () {
  const openPopupEls = document.querySelectorAll(
    "." + productOptionsCl.popupOpenEl,
  );
  if (openPopupEls.length < 1) return;

  const quantityInput = document.querySelector(
    "." + productOptionsCl.quantityInput,
  );

  openPopupEls.forEach((openEl) => {
    addPopupEvents(openEl, quantityInput);
  });
};

/* PRODUCT POPUP - END */

/* PRODUCT STRENGTH - START */

const addStrengthEvents = function (
  strengthWrapper,
  strengthRadios,
  quantityInput,
) {
  strengthWrapper.addEventListener("click", (e) => {
    if (e.target.closest("." + productOptionsCl.strengthRadio)) {
      const radioInput = e.target
        .closest("." + productOptionsCl.strengthRadio)
        .querySelector("input");
      if (radioInput.hasAttribute("disabled")) return;
      resetProductQuantity(quantityInput);
      switchPriceTag(radioInput);

      let _variant = radioInput.value

      if(_variant == '10mg'){
        document.querySelectorAll('.product-popup-radio-js input.twenty-only').forEach((f)=>{
          f.parentElement.classList.add('hidden');
        })

        document.querySelectorAll('.product-popup-radio-js input').forEach((f)=>{
          f.classList.add('filtered');
        })

        document.querySelectorAll('.product-popup-radio-js input.ten-only').forEach((f)=>{
          f.parentElement.classList.remove('hidden');
        })
      }

      if(_variant == '20mg'){

        document.querySelectorAll('.product-popup-radio-js input.twenty-only').forEach((f)=>{
          f.parentElement.classList.remove('hidden');
        })

        document.querySelectorAll('.product-popup-radio-js input').forEach((f)=>{

            if(f.dataset.variant2Inventory <= 0 &&  f.dataset.variantInventory > 0 && f.classList.contains('filtered')){
            f.parentElement.removeAttribute('out-of-stock');         
        } 
          f.classList.remove('filtered');
        
        })

        document.querySelectorAll('.product-popup-radio-js input.ten-only').forEach((f)=>{
          f.parentElement.classList.add('hidden');
        })
      }

    }
  });
};

const initProductStrength = function () {
  const strengthWrapper = document.querySelector(
    "." + productOptionsCl.strengthWrapper,
  );
  if (!strengthWrapper) return;

  const strengthRadios = [
    ...strengthWrapper.querySelectorAll("." + productOptionsCl.strengthRadio),
  ];
  const quantityInput = document.querySelector(
    "." + productOptionsCl.quantityInput,
  );

  addStrengthEvents(strengthWrapper, strengthRadios, quantityInput);
};

/* PRODUCT STRENGTH - END */

export default function () {
  initProductQuantity();
  initProductPopup();
  initProductStrength();
}
